import Vue from 'vue'
import Router from './Router'

export default {
	namespaced: true,
	state: {
		users: [],
		meta: null,
		loading: true,
		userDetail: {},
		isLoadingCreateUser: false,
		isLoadingDetail: false,
		emailError: null
	},
	getters: {
		adminAndManagerUsers({ users }) {
			return users.filter(user => !user.roles.includes('canPrepay'))
		}
	},
	actions: {
		async fetch({ commit }, query) {
			let response = await Vue.http.get('users', { params: query })
			commit('setList', response.body)
		},
		async checkEmail({ commit, dispatch }, query) {
			commit('setEmailError', null)
			try {
				await Vue.http.get('check-email', { params: query })
				dispatch('createUser', query)
			} catch (error) {
				commit('setEmailError', error.body.errors.email)
			}
		},
		async createUser({ commit }, data) {
			commit('setEmailError', null)
			try {
				commit('setLoadCreateUser', true)
				const response = await Vue.http.post(`users`, data)
				Router.push(`users/${response.body.id}`)
				commit('setLoadCreateUser', false)
			} catch (e) {
				commit('setLoadCreateUser', false)
				console.error(e)
			}
		},
		async fetchOne({ commit, rootState }) {
			try {
				commit('setLoadDetail', true)
				let userId = rootState.route.params.userId
				let response = await Vue.http.get('users/' + userId)
				commit('setOne', response.body)
				commit('setLoadDetail', false)
			} catch (e) {
				commit('setLoadDetail', false)
			}
		},

		async saveUser({ commit, rootState, state }) {
			try {
				let userId = rootState.route.params.userId
				let response = await Vue.http.post('users/' + userId, state.userDetail)
				commit('setOne', response.body)
				commit('setEmailError', null)
			} catch (error) {
				commit('setEmailError', error.body.errors.user_email)
			}
		},
		async changePassword({ commit, rootState }, { password }) {
			let userId = rootState.route.params.userId
			await Vue.http.post(`users/${userId}/change-password`, { password })
		},

		async deleteAvatar({ dispatch, rootState }) {
			let id = rootState.route.params.userId
			await Vue.http.delete(`users/${id}/delete-avatar`)
			dispatch('fetchOne')
		},

		async createAddress({ rootState, commit }, data) {
			const id = rootState.route.params.userId
			let response = await Vue.http.post(`addresses`, { ...data, addressable_id: id })
			data.id = response.body.addressId
			commit('addAddress', data)
		},
		async updateAddress({ commit }, data) {
			await Vue.http.post(`addresses/${data.id}`, data)
			commit('updateAddress', data)
		},
		async deleteAddress({ commit }, id) {
			await Vue.http.delete(`addresses/${id}`)
			commit('deleteAddress', id)
		}
	},
	mutations: {
		setList(state, users) {
			state.users = users.data
			state.meta = users.meta
			state.loading = false
		},
		setEmailError(state, error) {
			state.emailError = error
		},
		setOne(state, userDetail) {
			state.userDetail = { ...userDetail }
		},
		setLoadCreateUser(state, status) {
			state.isLoadingCreateUser = status
		},
		setLoadDetail(state, status) {
			state.isLoadingDetail = status
		},
		setAvatar(state, avatar) {
			state.userDetail.avatar = avatar
		},

		addAddress(state, address) {
			state.userDetail.user_home_address = [address]
		},
		updateAddress(state, address) {
			state.userDetail.user_home_address = state.userDetail.user_home_address.map(
				item => {
					if (item.id === address.id) {
						item = address
					}
					return item
				}
			)
		},
		deleteAddress(state, addressId) {
			state.userDetail.user_home_address = state.userDetail.user_home_address.filter(
				item => item.id !== addressId
			)
		}
	}
}
